import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import errorImageDark from '../../assets/errorImageDark.svg';
import errorImageLight from '../../assets/errorImageLight.svg';

const messages = defineMessages({
	errorTitle: {
		id: 'user-profile-preview.error.title',
		defaultMessage: "Something went wrong and we couldn't find this person.",
		description: 'Error title when the user profile preview fails to load',
	},
	errorDescription: {
		id: 'user-profile-preview.error.description',
		defaultMessage: 'Try searching for them again.',
		description: 'Error description suggesting the user try again',
	},
});

const styles = cssMap({
	root: {
		backgroundColor: token('elevation.surface.sunken'),
		paddingTop: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
		borderRadius: token('radius.large'),
	},
});

interface ErrorCardProps {
	testId?: string;
}

export function ErrorCard({ testId = 'user-profile-preview-error' }: ErrorCardProps): React.JSX.Element {
	const intl = useIntl();

	return (
		<Inline space="space.200" alignBlock="center" testId={testId} xcss={styles.root}>
			<Image src={errorImageLight} srcDark={errorImageDark} role="presentation" alt="" />
			<Stack space="space.050">
				<Text color="color.text.subtlest">{intl.formatMessage(messages.errorTitle)}</Text>
				<Text size="small" color="color.text.subtlest">
					{intl.formatMessage(messages.errorDescription)}
				</Text>
			</Stack>
		</Inline>
	);
}
